export const InitialFilters = {
    defaultSort: undefined,
    defaultFilters: undefined,
};
